export const PLOTLINE_CREATE_REQUEST = 'PLOTLINE_CREATE_REQUEST';
export const PLOTLINE_CREATE_SUCCESS = 'PLOTLINE_CREATE_SUCCESS';
export const PLOTLINE_CREATE_FAIL = 'PLOTLINE_CREATE_FAIL';

export const PLOTLINE_LIST_REQUEST = 'PLOTLINE_LIST_REQUEST';
export const PLOTLINE_LIST_SUCCESS = 'PLOTLINE_LIST_SUCCESS';
export const PLOTLINE_LIST_FAIL = 'PLOTLINE_LIST_FAIL';